var _g, _circle, _circle2, _circle3, _path, _path2, _path3, _g2, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHowDoesItWorkIcon = function SvgHowDoesItWorkIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#69DAFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 144.284,
    r: 110,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.999,
    cy: 137.144,
    r: 91.429,
    fill: "#00A89E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CE9A11",
    d: "M14.286 37.14h51.429v42.857H14.286z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.713 37.137c0 14.2-11.512 25.713-25.715 25.713-14.2 0-25.713-11.513-25.713-25.713 0-14.203 11.513-25.716 25.713-25.716 14.203 0 25.715 11.513 25.715 25.716Z",
    fill: "#FFDE2E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 37,
    width: 52,
    height: 45
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBAE0E",
    d: "M14.283 37.137h51.429v44.286H14.283z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.855 42.852c0 14.81 11.968 25.714 27.143 25.714 15.178 0 27.143-10.904 27.143-25.714h5.714c0 18.325-14.895 31.429-32.857 31.429-17.958 0-32.857-13.104-32.857-31.429h5.714Z",
    fill: "#FFDE2E"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.999 37.138c0 11.045-8.955 20-20 20-11.046 0-20-8.955-20-20 0-11.047 8.954-20 20-20 11.045 0 20 8.953 20 20Z",
    fill: "#EBAE0E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.313 54.345v-3.83c-2.713-.12-5.345-.846-6.885-1.73l1.216-4.716c1.702.927 4.091 1.774 6.722 1.774 2.309 0 3.887-.89 3.887-2.5 0-1.531-1.294-2.499-4.292-3.505-4.333-1.451-7.29-3.465-7.29-7.377 0-3.545 2.513-6.327 6.844-7.172v-3.828h3.97v3.547c2.712.121 4.534.684 5.87 1.33l-1.172 4.552c-1.054-.442-2.917-1.369-5.832-1.369-2.633 0-3.483 1.13-3.483 2.256 0 1.33 1.418 2.177 4.86 3.467 4.818 1.692 6.763 3.908 6.763 7.536 0 3.585-2.552 6.65-7.209 7.455v4.11h-3.97Z",
    fill: "#FFDE2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: -3,
    width: 80,
    height: 83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHowDoesItWorkIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "how-does-it-work-icon.315ccc6e9e1bf7857c7effd401fec87a.svg";